<script>
  import options from './FrivilligeCheckoutStepOne.options'
  export default options
</script>

<template>
  <article
    class="kb-forms kb-checkout-step-one kb-frivillige-checkout-step-one">
    <section class="kb-checkout-step-one__customer-info">

      <div class="kb-checkout-step-one__form-wrapper">
        <FormInputTextField
          isRequired
          v-model="userInformation.contactFirstName"
          fieldName="firstName"
          autocomplete="given-name"
          :label="getLabel('firstNameLabel')"
          :placeholder="getLabel('firstNamePlaceholder')"
          disabled="true"
        />

        <FormInputTextField
          isRequired
          v-model="userInformation.contactLastName"
          fieldName="lastName"
          autocomplete="family-name"
          :label="getLabel('lastNameLabel')"
          :placeholder="getLabel('lastNamePlaceholder')"
          disabled="true"
        />
      </div>

      <div class="kb-checkout-step-one__form-wrapper">
        <FormInputTextField
          isRequired
          v-model="userInformation.email"
          fieldName="email"
          autocomplete="email"
          :label="getLabel('emailLabel')"
          :placeholder="getLabel('emailPlaceholder')"
          disabled="true"
        />

        <FormInputTextField
          v-model="phoneInput"
          fieldName="phone"
          autcomplete="tel"
          isRequired
          :label="getLabel('phoneLabel')"
          :placeholder="getLabel('phonePlaceholder')"
          :isValidationError="!phoneInputFilled && displayErrorMessages"
          :errorMessageLabel="getLabel('validationPhone')"
          :disabled="disablePhoneInput"
        />
      </div>
      <div class="kb-checkout-step-one__form-wrapper">
        <FormAddressField
          v-model:address-line-value="invoiceAddress.addressLine"
          v-model:zip-code-value="invoiceAddress.postalCode"
          v-model:city-value="invoiceAddress.city"
          :addressLabel="getLabel('addressLineLabel')"
          :zipCodeLabel="getLabel('postalCodeLabel')"
          :addressPlaceholder="getLabel('addressLinePlaceholder')"
          :zipCodePlaceholder="getLabel('postalCodePlaceholder')"
          :cityPlaceholder="getLabel('cityPlaceholder')"
          :cityLabel="getLabel('cityLabel')"
          :isValidationError="false"
          :errorMessageLabel="getLabel('validationAddressLine')"
          :disabled="true"
        />
      </div>
    </section>

    <div class="kb-checkout-step-one__navigation">
      <div class="kb-checkout-step-one__navigation-breaker">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 704 1" aria-hidden="true" role="presentation">
          <path fill="#DFDFDB" d="M0 0h704v1H0z" />
        </svg>
      </div>
      <div class="kb-checkout-step-one__navigation-button-wrapper">
        <a 
          :href="getLabel('cancelButtonUrl')"
          class="kb-button"
        >
          {{ getLabel("cancelButtonText") }}
      </a>
        <button
          v-on:click="onSubmit"
          class="kb-checkout-step-one__bottom-button submit kb-button kb-button--full-color-spot"
        >
          {{ getLabel("submitButtonTextStep1") }}
        </button>
      </div>
    </div>
  </article>
</template>
